// store
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { TypesState } from '@fund-base/store/state/types.state';
import { featureTypesKey } from '@fund-base/store/reducers/types.reducer';
import { FundType, Interest } from '@fund-base/types/types/types.types';
// loading
const getLoading = (state: TypesState): boolean => state.loading;

// fund types
const getFundTypes = (state: TypesState): FundType[] => state.fundTypes;

// interests
const getInterests = (state: TypesState): Interest[] => state.interests;

// types state
export const selectTypesState: MemoizedSelector<object, TypesState> =
  createFeatureSelector<TypesState>(featureTypesKey);

// loading
export const selectTypesLoading: MemoizedSelector<object, boolean> = createSelector(selectTypesState, getLoading);

// fund types
export const selectFundTypes: MemoizedSelector<object, FundType[]> = createSelector(selectTypesState, getFundTypes);

// interest
export const selectInterests: MemoizedSelector<object, Interest[]> = createSelector(selectTypesState, getInterests);
